<template>
  <div class="login-shell">
    <v-snackbar v-model="aviso_login" :timeout="4000" top right>
      {{ msg_login }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="aviso_login = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <div class="login-shell__walkway" aria-hidden="true">
      <div class="login-shell__walker">
        <div class="login-shell__walker-shadow"></div>
        <img :src="walker" alt="" />
      </div>
    </div>

    <div class="login-shell__panel">
   

      <section class="login-shell__card">
        <div class="login-shell__card-inner">
          <div class="login-shell__eyebrow">Acesso seguro</div>
          <h2 class="login-shell__form-title">Entrar no painel</h2>
          <p class="login-shell__form-copy">
            Use seu login de atendimento para acessar a operacao.
          </p>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Login"
              placeholder="Preencha seu login"
              outlined
              v-model="login"
              :rules="loginRules"
              required
              prepend-inner-icon="mdi-account-outline"
            >
            </v-text-field>

            <v-text-field
              label="Senha"
              placeholder="Preencha sua senha"
              outlined
              v-model="password"
              :rules="passwordRules"
              required
              type="password"
              prepend-inner-icon="mdi-lock-outline"
            ></v-text-field>

            <div class="login-card__options">
              <span class="login-card__hint">Manter meu login preenchido</span>
              <v-switch
                v-model="checkbox"
                inset
                class="login-card__switch"
                hide-details
              ></v-switch>
            </div>

            <v-btn
              :disabled="!valid"
              color="primary"
              class="login-card__submit"
              @click="validate"
              :loading="dialog"
              block
              large
            >
              <v-icon left>mdi-login-variant</v-icon>
              Entrar
            </v-btn>
          </v-form>
        </div>
      </section>

         <section class="login-shell__hero">
        <div class="login-shell__badge">Genesys Supogen</div>

        <div class="login-shell__brand">
          <!-- <img :src="logo" alt="Genesys" /> -->
          <div class="login-shell__brand-copy">
            <span>Painel operacional</span>
            <strong>Workspace da Genesys</strong>
          </div>
        </div>

        <h1 class="login-shell__headline">
          Atendimento organizado, rapido e pronto para operacao.
        </h1>
        <p class="login-shell__lead">
          Entre no workspace para acompanhar chamados, registrar interacoes e
          conduzir a fila com mais contexto.
        </p>

       
      </section>
    </div>
  </div>
</template>
<script>
import Usuario from "../domain/Usuario";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("Usuarios", ["usuario"]),
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
  },

  data: () => ({
    logo: require("../assets/logo.png"),
    walker: require("../assets/robo.gif"),
    highlights: [
      {
        icon: "mdi-view-dashboard-outline",
        title: "Fila visivel",
        text: "Acompanhe chamados, etapas e interacoes em um unico fluxo.",
      },
      {
        icon: "mdi-account-voice",
        title: "Atendimento contextual",
        text: "Consulte historico e mantenha cada resposta conectada ao caso.",
      },
      {
        icon: "mdi-shield-check-outline",
        title: "Acesso direto",
        text: "Entre rapido e siga para o painel operacional sem desvio.",
      },
    ],
    valid: true,
    login: "",
    loginRules: [(v) => !!v || "Login e obrigatorio"],
    password: "",
    passwordRules: [(v) => !!v || "Senha e obrigatoria"],
    checkbox: false,
    dialog: false,
    aviso_login: false,
    msg_login: "",
  }),

  mounted() {
    var usuario = this.getUser;
    if (typeof usuario.id != "undefined") {
      this.checkbox = true;
      this.login = usuario.login;
    } else {
      this.checkbox = false;
      this.login = "";
    }

    this.password = "";
  },

  methods: {
    ...mapActions("Usuarios", ["populaUsuario", "setMenu"]),
    validate() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.dialog = true;
      this.$loading.show();
      this.service = new Usuario(this.$resource);
      this.service.get(this.login, this.password).then(
        function (usr) {
          if (usr.length <= 0) {
            this.dialog = false;
            this.$loading.hide();
            this.msg_login = "Usuario e senha nao conferem";
            this.aviso_login = true;
            return;
          }

          this.populaUsuario(usr[0]);
          this.setMenu(0);

          this.$session.start();
          this.$session.set("id_tecnico", usr[0].id);
          this.$session.set("nome_tecnico", usr[0].nome);
          this.dialog = false;
          this.$loading.hide();

          this.$router.replace({ name: "inicial" });
        },
        (err) => {
          this.dialog = false;
          this.$loading.hide();
          this.msg_login = "Erro.: " + err;
          this.aviso_login = true;
        }
      );
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
